import { render, staticRenderFns } from "./DataSourceHandler.vue?vue&type=template&id=12d7e7f3&scoped=true&"
import script from "./DataSourceHandler.vue?vue&type=script&lang=ts&"
export * from "./DataSourceHandler.vue?vue&type=script&lang=ts&"
import style0 from "./DataSourceHandler.vue?vue&type=style&index=0&id=12d7e7f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d7e7f3",
  null
  
)

export default component.exports